import { MappingType } from '@sendent/nextcloud-api';
import { Circle, DefaultFolder } from '../../../services/microsoft/msGraphApi';
import { DefaultFolderModalStep } from '../../reducers/defaultFolder/reducer';
import { createReduxAction, ReduxAction } from '../../utils';
import { DefaultFolderActionType } from './actionTypes';

type SetDefaultFolderPayload = {
    defaultFolder: DefaultFolder;
};

type SetDefaultFolder = ReduxAction<
    DefaultFolderActionType.SetDefaultFolder,
    SetDefaultFolderPayload
>;

export const setDefaultFolder = (
    defaultFolder: DefaultFolder,
): SetDefaultFolder =>
    createReduxAction(DefaultFolderActionType.SetDefaultFolder, {
        defaultFolder,
    });

type SetDefaultFolderModalStepPayload = {
    step: DefaultFolderModalStep | null;
};

type SetDefaultFolderModalStep = ReduxAction<
    DefaultFolderActionType.SetDefaultFolderModalStep,
    SetDefaultFolderModalStepPayload
>;

export const setDefaultFolderModalStep = (
    step: DefaultFolderModalStep | null,
): SetDefaultFolderModalStep =>
    createReduxAction(DefaultFolderActionType.SetDefaultFolderModalStep, {
        step,
    });

type SetFormDefaultFolderScopePayload = {
    scope: MappingType | null;
};

type SetFormDefaultFolderScope = ReduxAction<
    DefaultFolderActionType.SetFormDefaultFolderScope,
    SetFormDefaultFolderScopePayload
>;

export const setFormDefaultFolderScope = (
    scope: MappingType | null,
): SetFormDefaultFolderScope =>
    createReduxAction(DefaultFolderActionType.SetFormDefaultFolderScope, {
        scope,
    });

type SetFormDefaultFolderCirclesPayload = {
    circle: Circle | null;
};

type SetFormDefaultFolderCircles = ReduxAction<
    DefaultFolderActionType.SetFormDefaultFolderCircles,
    SetFormDefaultFolderCirclesPayload
>;

export const setFormDefaultFolderCircles = (
    circle: Circle | null,
): SetFormDefaultFolderCircles =>
    createReduxAction(DefaultFolderActionType.SetFormDefaultFolderCircles, {
        circle,
    });

type SetFormDefaultFolderIdPayload = {
    id: number | null;
};

type SetFormDefaultFolderId = ReduxAction<
    DefaultFolderActionType.SetFormDefaultFolderId,
    SetFormDefaultFolderIdPayload
>;

export const setFormDefaultFolderId = (
    id: number | null,
): SetFormDefaultFolderId =>
    createReduxAction(DefaultFolderActionType.SetFormDefaultFolderId, {
        id,
    });

type SetFormDefaultFolderPathPayload = {
    path: string | null;
};

type SetFormDefaultFolderPath = ReduxAction<
    DefaultFolderActionType.SetFormDefaultFolderPath,
    SetFormDefaultFolderPathPayload
>;

export const setFormDefaultFolderPath = (
    path: string | null,
): SetFormDefaultFolderPath =>
    createReduxAction(DefaultFolderActionType.SetFormDefaultFolderPath, {
        path,
    });
